import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-start pl-3 py-2 bg-grey-lighten-4 rounded" }
const _hoisted_2 = { class: "mr-2 text-caption text-grey" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "text-body-2" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_7 = {
  key: 0,
  class: "ml-4 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_CompositionTree = _resolveComponent("CompositionTree", true)!

  return (_ctx.filteredCompositions.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['composition-level', `level-${_ctx.level}`])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCompositions, (composition) => {
          return (_openBlock(), _createElementBlock("div", {
            key: composition.uriComposant,
            class: "composition-item mb-2"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(composition.rang) + ".", 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    icon: composition.typeComposant === 'Product' ? 'mdi-package-variant' : 'mdi-food-variant',
                    size: "x-small",
                    color: composition.typeComposant === 'Product' ? 'orange' : 'green',
                    class: "mr-1"
                  }, null, 8, ["icon", "color"]),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(composition.nameComposant), 1)
                ]),
                (composition.tagComposant && composition.tagComposant.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(composition.tagComposant.slice(0, 3), (tag) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          key: tag,
                          size: "x-small",
                          variant: "outlined",
                          color: "primary",
                          class: "mr-1 mb-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (composition.tagComposant.length > 3)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            size: "x-small",
                            variant: "outlined",
                            color: "grey",
                            class: "mr-1 mb-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" +" + _toDisplayString(composition.tagComposant.length - 3), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.hasSubComponents(composition.uriComposant))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_CompositionTree, {
                    uri: composition.uriComposant,
                    compositions: _ctx.compositions,
                    showAll: _ctx.showAll,
                    level: _ctx.level + 1
                  }, null, 8, ["uri", "compositions", "showAll", "level"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}